/**
 * AWS Amplify configuration for Cognito authentication.
 * Uses the US production Cognito User Pool for ops dashboard authentication.
 */

import { Amplify, ResourcesConfig } from 'aws-amplify';

// Cognito configuration from environment variables
const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID || '';
const userPoolClientId = import.meta.env.VITE_COGNITO_CLIENT_ID || '';
const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN || '';
const region = import.meta.env.VITE_COGNITO_REGION || 'us-east-1';

/**
 * Configure Amplify for authentication.
 */
export function configureAmplify() {
  if (!userPoolId || !userPoolClientId) {
    console.warn('Cognito configuration missing - auth features will not work');
    console.warn('Set VITE_COGNITO_USER_POOL_ID and VITE_COGNITO_CLIENT_ID');
    return;
  }

  const authConfig: ResourcesConfig['Auth'] = {
    Cognito: {
      userPoolId,
      userPoolClientId,
      signUpVerificationMethod: 'code',
      loginWith: {
        oauth: {
          domain: cognitoDomain,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [`${window.location.origin}/auth/callback`],
          redirectSignOut: [`${window.location.origin}/`],
          responseType: 'code',
        },
      },
    },
  };

  Amplify.configure({ Auth: authConfig });
}

/**
 * Check if Amplify/Cognito is configured.
 */
export function isAmplifyConfigured(): boolean {
  return !!(userPoolId && userPoolClientId);
}

/**
 * Export config values for direct access.
 */
export const amplifyConfig = {
  userPoolId,
  userPoolClientId,
  cognitoDomain,
  region,
};
